// Expected errors, that are not worth logging in Panorama
const EXPECTED_ERROR_PREFIXES = [
  'Got stale transaction ID',
  'Snapshot was removed by client due to conflict',
];

export function isExpectedError(err: unknown): boolean {
  return (
    err instanceof Error &&
    EXPECTED_ERROR_PREFIXES.some((prefix) => err.message.startsWith(prefix))
  );
}
